import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { dateJP } from "@/lib/format";
import { Loader2, AlertTriangle, FileClock, Landmark, Bell } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ICON = { arrears: AlertTriangle, contract_renewal: FileClock, loan: Landmark };
const ROUTE = { arrears: "/arrears", contract_renewal: "/contracts", loan: "/loans" };
const LEVEL = {
  error: "border-l-red-500 bg-red-50/50",
  warning: "border-l-amber-500 bg-amber-50/50",
  info: "border-l-blue-500 bg-blue-50/50",
};
const LEVEL_LABEL = { error: "緊急", warning: "注意", info: "お知らせ" };

export default function Notifications() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/notifications").then(({ data }) => setItems(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="animate-fade-in">
      <PageHeader title="通知" subtitle="家賃未入金・契約更新・ローン返済などの重要通知" />
      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-brand" /></div>
      ) : items.length === 0 ? (
        <div className="bg-white border border-border rounded-sm py-16 text-center text-muted-foreground">
          <Bell className="w-10 h-10 mx-auto mb-3 text-gray-300" />通知はありません
        </div>
      ) : (
        <div className="space-y-2 max-w-3xl">
          {items.map((n, i) => {
            const Icon = ICON[n.type] || Bell;
            return (
              <button key={i} onClick={() => navigate(ROUTE[n.type] || "/")}
                className={`w-full text-left flex items-start gap-3 p-4 bg-white border border-border border-l-4 rounded-sm hover:bg-gray-50 transition-colors ${LEVEL[n.level]}`}
                data-testid={`notif-${i}`}>
                <Icon className={`w-5 h-5 shrink-0 mt-0.5 ${n.level === "error" ? "text-red-500" : n.level === "warning" ? "text-amber-500" : "text-blue-500"}`} />
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="font-medium text-sm">{n.title}</span>
                    <span className="text-[10px] px-1.5 py-0.5 rounded-sm bg-white border">{LEVEL_LABEL[n.level]}</span>
                  </div>
                  <div className="text-sm text-muted-foreground mt-0.5">{n.message}</div>
                </div>
                <span className="text-xs text-muted-foreground shrink-0">{dateJP(n.date)}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
